'use strict';
import React from 'react';
import './App.css';

const BgBar = () => {

    const handleClick = (props) => {
        const selectedBg = props;
        const backgrounds = {
            'desk': {
                backgroundImage: "url('img/desk.avif')"
            },

            'rain': {
                backgroundImage: "url('img/rainyday.jpg')"
            },

            'cafe': {
                backgroundImage: "url('img/cafe.jpg')"
            },

            'beach': {
                backgroundImage: "url('img/beach.jpg')"
            },

                'darkacademia': {
                    backgroundImage: "url('img/academia.jpg')"
            },

            'camp': {
                backgroundImage: "url('img/camp.jpg')"
            }
    }

    let background = backgrounds[selectedBg];
    if (background) {
        document.documentElement.style.backgroundImage = background.backgroundImage;
    }
};

    return(
        <div className="bg-toggle">
        <div className="bg-container">
            <div className="wrapper">
                <h1 className="fix">Backgrounds</h1>
            </div>
            <div className="wrapper">
                <div className="bg-content">
                <div className="bg-item">
                    <img src="img/desk.avif" alt="A brown desk with a black laptop, phone, and lamp" onClick={() => handleClick('desk')} />
                </div>
                <div className="bg-item">
                <img src="img/rainyday.jpg" alt="Rain droplets dripping off of a roof." onClick={() => handleClick('rain')} />
                </div>
                <div className="bg-item">
                <img src="img/cafe.jpg" alt="A table at a coffee shop." onClick={() => handleClick('cafe')} />
                </div>
                <div className="bg-item">
                <img src="img/beach.jpg" alt="A beach with a sunrise." onClick={() => handleClick('beach')}/>
                </div>
                <div className="bg-item">
                <img src="img/academia.jpg" alt="A bookshelf with a ladder in front of it" onClick={() => handleClick('darkacademia')} />
                </div>
                <div className="bg-item">
                <img src="img/camp.jpg" alt="A campfire at night." onClick={() => handleClick('camp')}/>
                </div>
            </div>
            </div>
        </div>
            </div>
    );

    
}

export default BgBar;